import React, { useMemo } from "react";

import moment from "moment";

import useDimensions from "src/organization/pages/project/environment/metrics/hooks/useDimensions";
import EnterpriseContainer from "src/organization/pages/project/environment/metrics/resources/enterprise/dedicated";
import isEnterpriseSplit from "src/organization/pages/project/environment/metrics/resources/enterprise/util";

import Split from "./split";

const EnterpriseView = ({ link }) => {
  const now = moment();
  const query = useMemo(
    () => ({
      stream: {
        collection: link?.collection,
        stream: "metrics"
      },
      range: {
        to: now.format(),
        from: now.subtract(15, "minutes").format()
      }
    }),
    [link?.collection, now]
  );

  const { dimension, isLoadingDimensions } = useDimensions(link?.href, query);

  const isSplit = isEnterpriseSplit(dimension);

  if (isLoadingDimensions) {
    return null;
  }

  return isSplit ? <Split link={link} /> : <EnterpriseContainer link={link} />;
};

export default EnterpriseView;
